import { z } from "zod";
import { ShortText, MediumText, LongText, ContainmentStatus, idString, } from "./common.js";
const ContainmentAction = z
    .object({
    id: idString,
    title: ShortText,
    detail: LongText.optional(),
    owner: ShortText,
    due: ShortText,
    status: ContainmentStatus,
    percentComplete: z.number().int().min(0).max(100),
})
    .strict();
/**
 * Containment Cards — Oppress, multi. Stop-the-bleed actions list with
 * owner, due, status pill, and a progress bar per item.
 */
export const ContainmentCardsParamsSchema = z
    .object({
    actions: z.array(ContainmentAction).max(100),
})
    .strict();
export const defaultContainmentCardsParams = {
    actions: [],
};
// Silence "imported but unused" for the cleaner export style.
void MediumText;
//# sourceMappingURL=containmentCards.js.map